import React from 'react';
import './Events.css';

import {events} from '../content/events/events';

import eventply from '../media/plymouthlit.png';
import basingstokecrime from '../media/basingstokecrime.jpg';

const imageMap = {
  plymouthlit: eventply,
  basingstokecrime: basingstokecrime,
};

function Events() {
  return (
    <div className='Events'>
      <div className='eventspage'>
        <h1 className='text-center'>Events</h1>

        {events.map((event, index) => (
          <div key={event.id}>
            <div className='row m-auto p-1 p-sm-3 align-items-center event'>
              <div className='col-12 col-md-6 text-center text-md-end my-4'>
                {imageMap[event.imageKey] && (
                  <img
                    src={imageMap[event.imageKey]}
                    alt={event.title}
                    className='w-50 img-fluid eventImage'
                  />
                )}
              </div>

              <div className='col-12 col-md-6 text-center text-md-start'>
                <h2>{event.title}</h2>
                <p>{event.date}</p>

                {event.description.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}

                {event.link && (
                  <div className='mt-3'>
                    <a
                      href={event.link.url}
                      target='_blank'
                      rel='noreferrer'
                      className='linkLightBase'>
                      {event.link.label}
                    </a>
                  </div>
                )}
              </div>
            </div>

            {index < events.length - 1 && <hr className='d-md-none' />}
          </div>
        ))}

        {/* Freelance Media Group (static section) */}
        <hr />

        <div className='event1'>
          <h2 className='ms-2 highlight'>THE FREELANCE MEDIA GROUP</h2>

          <p>
            I help to run the <i>Freelance Media Group</i> which generally meets
            in London at <i>The University Women's Club</i>. When the virus
            struck, we turned to Zoom and currently run online meetings with
            speakers from publishing.
          </p>

          <p>
            If you'd like to join us online, please email me at
            <a
              href='mailto:janecorryauthor@gmail.com'
              className='mx-2 linkLightBase'>
              janecorryauthor@gmail.com
            </a>
          </p>

          <div>
            <a
              href='mailto:janecorryauthor@gmail.com?subject=Freelance Media Group&body=I would like to join the online meetings with the Freelance Media Group!'
              className='px-3 btnLightDark joinbutton'>
              click here to join
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Events;
